export default {
  DESIGNER: 'CLIENT-SUB-DESIGNER',
  TEAM_MEMBER: 'CLIENT-SUB-TEAM-MEMBER',
  ADMIN: 'CLIENT-SUB-ADMIN',
  CLIENT: 'CLIENT-PRO',
};

export const privileges = {
  DASHBOARD: 'dashboard',
  CAMPAIGNS: 'campaigns',
  ORDERS: 'orders',
  PROMOTIONS: 'promotions',
  SETTINGS: 'settings',
  ACADEMY: 'academy',
  STORES: 'stores',

  CAMPAIGNS_CSV: 'campaignsCsv',

  DASHBOARD_EARNINGS: 'dashboardEarnings',
  DASHBOARD_ORDERS: 'dashboardOrders',
  DASHBOARD_VISITORS: 'dashboardVisitors',
  DASHBOARD_CONVERSION: 'dashboardConversion',
  DASHBOARD_VISITORS_CHART: 'dashboardVisitorsChart',
  DASHBOARD_VISITORS_DATA: 'dashboardVisitorsData',
  DASHBOARD_REGIONAL_CHART: 'dashboardRegionalChart',
  DASHBOARD_REGIONAL_DATA: 'dashboardRegionalData',
  DASHBOARD_DEVICES_CHART: 'dashboardDevicesChart',
  DASHBOARD_DEVICES_DATA: 'dashboardDevicesData',
  DASHBOARD_REFERRALS_CHART: 'dashboardReferralsChart',
  DASHBOARD_REFERRALS_DATA: 'dashboardReferralsData',
  DASHBOARD_MOST_VISITED_CHART: 'dashboardMostVisitedChart',
  DASHBOARD_MOST_VISITED_DATA: 'dashboardMostVisitedData',
  DASHBOARD_HEATMAP: 'dashboardHeatmap',
  DASHBOARD_PRODUCTS: 'dashboardProucts',
  DASHBOARD_UPSELL_PERFORMANCE: 'dashboardUpsellPerformance',

  CAMPAIGN_RELAUNCH_DASHBOARD: 'campaignRelaunchDashboard',
  CAMPAIGN_DASHBOARD: 'campaignDashboard',
  CAMPAIGN_ORDERS: 'campaignOrders',
  CAMPAIGN_PROMOTIONS: 'campaignPromotions',
  CAMPAIGN_DETAILS: 'campaignDetails',
  CAMPAIGN_MARKETING: 'campaignMarketing',
  CAMPAIGN_ASSETS: 'campaignAssets',
  CAMPAIGN_AD_FACTORY: 'campaignAdFactory',

  CAMPAIGN_DUPLICATE: 'campaignDuplicate',
  CAMPAIGN_EMBED: 'campaignEmbed',
  CAMPAIGN_STAR: 'campaignStar',
  CAMPAIGN_EXTEND: 'campaignExtend',
  CAMPAIGN_END: 'campaignEnd',
  CAMPAIGN_RELAUNCH: 'campaignRelaunch',
  CAMPAIGN_EMAIL_REP: 'campaignEmailRep',

  SETTINGS_NAV: 'settingsNav',
  SETTINGS_ACCOUNT: 'settingsAccount',
  SETTINGS_CHANGE_PASSWORD: 'settingsChangePassword',
  SETTINGS_ACCOUNT_NOTIFICATIONS: 'settingsAccountNotifications',
  SETTINGS_USERS: 'settingsUsers',
  SETTINGS_USERS_ADMIN: 'settingsUsersAdmin',
  SETTINGS_USERS_TEAM_MEMBER: 'settingsUsersTeamMember',
  SETTINGS_USERS_DESIGNER: 'settingsUsersDesigner',
  SETTINGS_TRACKING: 'settingsTracking',
  SETTINGS_PAYMENT: 'settingsPayment',
  SETTINGS_REFERRALS: 'settingsReferrals',
  SETTINGS_EMAILS: 'settingsEmails',
  SETTINGS_AFFILIATE: 'settingsAffiliate',
  
  WHITELABEL: 'whitelabel',
};